exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 576px) {\n  .style__tile___1w5_V:nth-child(-n+3) {\n    margin-bottom: 10px; } }\n", ""]);

// exports
exports.locals = {
	"tile": "style__tile___1w5_V"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/MultiLevelSelectorWithLogo/LogoSelector/style.scss
// module id = 3878
// module chunks = 6